// GA4 Event Tracking Utility Functions

// Google Analytics 4 Measurement ID
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'; // Replace with your actual GA4 Measurement ID

// Initialize GA4
export const initializeGA = () => {
  if (typeof window !== 'undefined') {
    // Add the Google Analytics script to head
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);

    // Make gtag available globally
    window.gtag = gtag;
  }
};

// Track page views
export const trackPageView = (page_title, page_path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_title,
      page_path,
      send_to: GA_MEASUREMENT_ID
    });
  }
};

// Track brochure requests
export const trackBrochureRequest = (brochureId, brochureTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'brochure_request', {
      event_category: 'engagement',
      event_label: brochureTitle,
      brochure_id: brochureId,
      send_to: GA_MEASUREMENT_ID
    });
  }
};

// Track form submissions
export const trackFormSubmission = (formType, formName, success) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'form_submission', {
      event_category: 'forms',
      event_label: formName,
      form_type: formType,
      success: success,
      send_to: GA_MEASUREMENT_ID
    });
  }
};

// Track brochure views
export const trackBrochureView = (brochureId, brochureTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'brochure_view', {
      event_category: 'content',
      event_label: brochureTitle,
      brochure_id: brochureId,
      send_to: GA_MEASUREMENT_ID
    });
  }
};

// Track user interactions
export const trackUserInteraction = (action, category, label) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      send_to: GA_MEASUREMENT_ID
    });
  }
};

// Generic click event tracking
export const trackClick = (elementName, elementType, elementLocation) => {
  if (typeof window.gtag !== 'function') return;
  
  window.gtag('event', 'click', {
    element_name: elementName,
    element_type: elementType,
    element_location: elementLocation,
  });
};

// Contact form tracking
export const trackContactFormSubmission = (formData) => {
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', 'generate_lead', {
    form_type: 'contact',
    destination: formData.destination || 'not_specified',
    marketing_opt_in: formData.subscribe,
  });
}; 